// Saison Interclubs 2026 - Source unique de données
// Mise à jour : quand un résultat est connu, remplacez "0:0" par le score réel (ex. "8:1").
// La page d'accueil affichera automatiquement le prochain match 0:0 à venir.

const SEASON_YEAR = 2026;

// Parse "DD.MM" -> Date object (année saison)
export const parseMatchDate = (dateStr) => {
  const [day, month] = dateStr.split('.').map((s) => parseInt(s, 10));
  return new Date(SEASON_YEAR, month - 1, day);
};

const isCheyres = (name) => name && name.includes('Cheyres');

// Renvoie le prochain match 0:0 impliquant Cheyres, à venir (date >= aujourd'hui)
export const getNextCheyresMatch = (matches) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const candidates = matches
    .filter((m) => isCheyres(m.home) || isCheyres(m.away))
    .filter((m) => m.score === '0:0')
    .filter((m) => parseMatchDate(m.date) >= today)
    .sort((a, b) => parseMatchDate(a.date) - parseMatchDate(b.date));
  return candidates[0] || null;
};

// ============================================================
// ACTIFS - Équipe 35+ Messieurs · 3L Groupe 22
// ============================================================
export const actifsTeam = {
  id: 'actifs-35-3l',
  label: 'Actifs · 35+ 3L',
  fullTitle: 'Équipe 35+ Messieurs - 3L Groupe 22',
  category: '35+ 3L Messieurs',
};

export const actifsMatches = [
  // Tour 1
  { tour: 1, date: '03.05', time: null,    home: 'Béroche-B.-Boudry', away: 'Ste-Croix/Fribourg', score: '8:1' },
  { tour: 1, date: '02.05', time: '9h00',  home: 'Cheyres-Châbles',   away: 'Domdidier',         score: '8:1' },
  { tour: 1, date: '02.05', time: null,    home: 'Gletterens',        away: 'Mail NE',           score: '7:2' },
  // Tour 2
  { tour: 2, date: '09.05', time: '9h00',  home: 'Mail NE',           away: 'Ste-Croix/Fribourg', score: '4:5' },
  { tour: 2, date: '09.05', time: '12h30', home: 'Domdidier',         away: 'Béroche-B.-Boudry',  score: '5:4' },
  { tour: 2, date: '09.05', time: '9h00',  home: 'Cheyres-Châbles',   away: 'Gletterens',         score: '7:2' },
  // Tour 3
  { tour: 3, date: '17.05', time: '9h00',  home: 'Béroche-B.-Boudry', away: 'Cheyres-Châbles',    score: '6:3' },
  { tour: 3, date: '17.05', time: '9h00',  home: 'Mail NE',           away: 'Domdidier',          score: '6:3' },
  { tour: 3, date: '16.05', time: '9h00',  home: 'Ste-Croix/Fribourg', away: 'Gletterens',        score: '4:5' },
  // Tour 4
  { tour: 4, date: '20.06', time: '13h00', home: 'Domdidier',         away: 'Ste-Croix/Fribourg', score: '0:0' },
  { tour: 4, date: '07.06', time: null,    home: 'Cheyres-Châbles',   away: 'Mail NE',            score: '9:0' },
  { tour: 4, date: '06.06', time: null,    home: 'Gletterens',        away: 'Béroche-B.-Boudry',  score: '3:6' },
  // Tour 5
  { tour: 5, date: '13.06', time: null,    home: 'Mail NE',           away: 'Béroche-B.-Boudry',  score: '4:5' },
  { tour: 5, date: '13.06', time: null,    home: 'Ste-Croix/Fribourg', away: 'Cheyres-Châbles',   score: '2:7' },
  { tour: 5, date: '14.06', time: '12h00', home: 'Domdidier',         away: 'Gletterens',         score: '0:0' },
];

export const actifsStandings = [
  { rank: 1, team: 'Cheyres-Châbles',    pts: 34, sets: '69 - 25' },
  { rank: 2, team: 'Béroche-B.-Boudry',  pts: 29, sets: '60 - 35' },
  { rank: 3, team: 'Gletterens',         pts: 17, sets: '39 - 38' },
  { rank: 4, team: 'Mail NE',            pts: 16, sets: '38 - 64' },
  { rank: 5, team: 'Ste-Croix/Fribourg', pts: 12, sets: '26 - 51' },
  { rank: 6, team: 'Domdidier',          pts:  9, sets: '19 - 38' },
];

// ============================================================
// JUNIORS - 3 équipes
// ============================================================
export const juniorsTeams = [
  {
    id: '15u-boys',
    label: '15&U Boys',
    fullTitle: '15&U Boys Ligue B - Groupe 97',
    category: 'Garçons U15',
    matches: [
      { tour: 1, date: '31.05', time: null,    home: 'Avenches',        away: 'Cheyres-Châbles', score: '1:2' },
      { tour: 1, date: '04.07', time: '10h00', home: 'Aiglon',          away: 'Grolley',         score: '0:0' },
      { tour: 2, date: '13.06', time: null,    home: 'Cheyres-Châbles', away: 'Grolley',         score: '0:3' },
      { tour: 2, date: '27.06', time: null,    home: 'Aiglon',          away: 'Avenches',        score: '2:1' },
      { tour: 3, date: '26.08', time: '17h30', home: 'Cheyres-Châbles', away: 'Aiglon',          score: '0:0' },
      { tour: 3, date: '20.06', time: null,    home: 'Grolley',         away: 'Avenches',        score: '3:0' },
    ],
    standings: [
      { rank: 1, team: 'Grolley',         pts: 6, sets: '12 - 0' },
      { rank: 2, team: 'Aiglon',          pts: 2, sets: '4 - 2' },
      { rank: 3, team: 'Cheyres-Châbles', pts: 2, sets: '4 - 9' },
      { rank: 4, team: 'Avenches',        pts: 2, sets: '5 - 14' },
    ],
  },
  {
    id: '15u-girls',
    label: '15&U Girls',
    fullTitle: '15&U Girls Ligue B - Groupe 40',
    category: 'Filles U15',
    matches: [
      { tour: 1, date: '13.06', time: null,    home: 'Cheyres-Châbles', away: 'Romont FR',       score: '0:3' },
      { tour: 1, date: '07.06', time: null,    home: 'Cudrefin 2',      away: 'Bulle',           score: '1:2' },
      { tour: 2, date: '10.06', time: null,    home: 'Cheyres-Châbles', away: 'Cudrefin 2',      score: '0:3' },
      { tour: 2, date: '19.06', time: null,    home: 'Bulle',           away: 'Romont FR',       score: '2:1' },
      { tour: 3, date: '28.06', time: null,    home: 'Bulle',           away: 'Cheyres-Châbles', score: '3:0' },
      { tour: 3, date: '30.05', time: null,    home: 'Romont FR',       away: 'Cudrefin 2',      score: '2:1' },
    ],
    standings: [
      { rank: 1, team: 'Bulle',           pts: 7, sets: '16 - 6' },
      { rank: 2, team: 'Romont FR',       pts: 6, sets: '12 - 9' },
      { rank: 3, team: 'Cudrefin 2',      pts: 5, sets: '12 - 9' },
      { rank: 4, team: 'Cheyres-Châbles', pts: 0, sets: '2 - 18' },
    ],
  },
  {
    id: 'kids-10u',
    label: 'Kids 10&U',
    fullTitle: 'Kids 10&U - Groupe 49',
    category: '10 ans et moins',
    matches: [
      { tour: 1, date: '10.06', time: null,    home: 'Bulle 1',         away: 'Marin 2',         score: '0:3' },
      { tour: 1, date: '31.05', time: null,    home: 'Grolley',         away: 'Cheyres-Châbles', score: '3:0' },
      { tour: 2, date: '21.06', time: null,    home: 'Marin 2',         away: 'Cheyres-Châbles', score: '3:0' },
      { tour: 2, date: '21.06', time: null,    home: 'Grolley',         away: 'Bulle 1',         score: '0:3' },
      { tour: 3, date: '27.06', time: null,    home: 'Marin 2',         away: 'Grolley',         score: '2:1' },
      { tour: 3, date: '14.06', time: null,    home: 'Cheyres-Châbles', away: 'Bulle 1',         score: '1:2' },
    ],
    standings: [
      { rank: 1, team: 'Marin 2',         pts: 8, sets: '17 - 4' },
      { rank: 2, team: 'Bulle 1',         pts: 5, sets: '11 - 8' },
      { rank: 3, team: 'Grolley',         pts: 4, sets: '9 - 12' },
      { rank: 4, team: 'Cheyres-Châbles', pts: 1, sets: '3 - 16' },
    ],
  },
];

// ============================================================
// Helpers d'affichage
// ============================================================
const DAYS_FR = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
const DAYS_FR_FULL = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
const MONTHS_FR = ['janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

export const formatMatchDate = (dateStr, opts = { full: false }) => {
  const d = parseMatchDate(dateStr);
  const dayName = opts.full ? DAYS_FR_FULL[d.getDay()] : DAYS_FR[d.getDay()];
  return `${dayName} ${d.getDate()} ${MONTHS_FR[d.getMonth()]}`;
};
